import { useQuery } from '@tanstack/react-query';

import {
  getAllAdvisoryReports,
  type GetAllAdvisoryReportsResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

import type { AdvisoryReport } from '../../types';

export default function useAdvisoryReports(
  partyId: string,
  filter?: {
    orderBy?: keyof AdvisoryReport;
    sort?: 'asc' | 'desc';
    from?: string;
  },
  options?: QueryOptions<GetAllAdvisoryReportsResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.advisoryReports.list(filter),
    queryFn: async () => {
      const result = await getAllAdvisoryReports(
        {
          query: {
            party_id: [partyId],
            order_by: filter?.orderBy ?? 'created_at',
            sort: filter?.sort ?? 'desc',
          },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
